import { z } from 'zod';
import { localeSchema } from './common';

export const priceOutput = z.object({
  id: z.string(),
  currency: z.string(),
  amountCents: z.number().int(),
  compareAtCents: z.number().int().nullable(),
  interval: z.enum(['one_time', 'month', 'quarter', 'year']),
  intervalCount: z.number().int(),
  label: z.string().nullable(),
  /**
   * Može li se po ovoj cijeni stvarno platiti.
   *
   * Cijena koju admin upravo doda postoji kod nas prije nego u Stripeu. Bez
   * ove oznake cjenik bi nudio gumb za kupnju koji vodi u grešku, pa umjesto
   * toga pokazuje cijenu i napomenu da paket još nije u prodaji.
   */
  sellable: z.boolean(),
});

export const productOutput = z.object({
  id: z.string(),
  slug: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  features: z.array(z.string()),
  deliveryMode: z.enum(['online', 'gym', 'hybrid']),
  accessDurationDays: z.number().int().nullable(),
  /** Koliko je treninga besplatno prije plaćanja. 0 = nijedan. */
  trialWorkoutCount: z.number().int(),
  highlighted: z.boolean(),
  prices: z.array(priceOutput),
});

export const faqOutput = z.object({
  id: z.string(),
  category: z.string(),
  question: z.string(),
  answer: z.string(),
});

export const testimonialOutput = z.object({
  id: z.string(),
  authorName: z.string(),
  authorAge: z.number().int().nullable(),
  text: z.string().nullable(),
  photoBeforeUrl: z.string().nullable(),
  photoAfterUrl: z.string().nullable(),
  videoUrl: z.string().nullable(),
  rating: z.number().int().min(1).max(5).nullable(),
  metrics: z.record(z.string(), z.union([z.string(), z.number()])).nullable(),
});

export const catalogQuery = z.object({ locale: localeSchema.default('hr') });

export type ProductOutput = z.infer<typeof productOutput>;
export type PriceOutput = z.infer<typeof priceOutput>;
export type FaqOutput = z.infer<typeof faqOutput>;
export type TestimonialOutput = z.infer<typeof testimonialOutput>;
